import type { GetAllOsVersionArtifactsByOsVersionIdV2QueryResponseApi } from '@ingenico/api-sdk-device-management-private-v2';
import { getTotalSize } from '../../../../utils/deviceAppVersionFile.util';
import type { FileListOsVersionProps } from '../../../models/osVersion.model';

export function mapOsArtifactsByOsVersionId({
  data,
}: GetAllOsVersionArtifactsByOsVersionIdV2QueryResponseApi): FileListOsVersionProps {
  const fileList = data.map(({ fileName: name, size, id }) => ({ name, size, id }));

  return {
    data: fileList,
    total: getTotalSize(fileList),
  };
}
